import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'qmMapValues'
})
export class QmMapValuesPipe implements PipeTransform {

  transform(value: Map<string, any>): { key: string, val: any }[] {
    const returnArray = [];

    value.forEach((entryVal, entryKey) => {
      returnArray.push({
        key: entryKey,
        val: entryVal
      });
    });

    return returnArray;
  }

}

